import React from 'react';

/**
 * Static PROVIDER column cell for the masking / encryption source tables. Providers live on
 * inventories now (a source can have several named inventories); the row carries the provider of
 * the source's most recently updated inventory, and this displays it (or the platform default —
 * "C2"). It is intentionally NOT editable here: the provider is chosen in the masking/encryption
 * inventory editor (where the algorithms live) and persisted on Save/Mask. This column then
 * reflects that saved state, so a user sees the provider change only after they've committed it.
 *
 * @param row          table row (carries the preferred-provider field off the latest inventory)
 * @param providers    [{ serviceId, name, vendorDisplayName, vendor, isDefault }] for this job family
 * @param field        'preferredMaskingProviderId' | 'preferredEncryptProviderId'
 * @param defaultLabel friendly label for C2's own default (e.g. "C2 Masking")
 */
function ProviderSelectCell({ row, providers, field, defaultLabel = 'C2' }) {
  const list = Array.isArray(providers) ? providers : [];
  const savedId = row && row[field];
  const selected =
    (savedId && list.find((p) => p.serviceId === savedId)) ||
    list.find((p) => p.isDefault) ||
    list[0] ||
    null;

  // Native C2 (no vendor) shows the friendly default label; 3rd-party shows its own name.
  const label = selected
    ? (selected.vendor ? (selected.vendorDisplayName || selected.name || selected.serviceId) : defaultLabel)
    : defaultLabel;

  return <span>{label}</span>;
}

export default ProviderSelectCell;
